import { ModalContext, type ModalContextValue } from '../context.js';
import { useContext } from 'react';

export const useModalContext = (): ModalContextValue => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('Cannot call useModalContext outside a `<Modal>`.');
  }

  return context;
};
